import { render } from "./info.vue?vue&type=template&id=3d2720b4&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3d2720b4"

export default script